import script from "./shoppingCart.vue?vue&type=script&setup=true&lang=js"
export * from "./shoppingCart.vue?vue&type=script&setup=true&lang=js"

import "./shoppingCart.vue?vue&type=style&index=0&id=136e2a29&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-136e2a29"]])

export default __exports__